export default {
  GET_LIST: '/manage/competitor-product/findList',
  SAVE_COMPETITOR: '/manage/competitor-product/save',
  GET_COMPETITOR_DETAIL: '/manage/competitor-product/find',
  UPDATE_COMPETITOR: '/manage/competitor-product/update',
  EXPORT_LIST: '/manage/competitor-product/exportList',
  GET_INCI: '/app/trade/inci/findInci',
  GET_FORMULATION_FUNCTION: '/auth/formulationFunction/list'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/competitor.js